export const isAce = (cardName) => [ 'Ac', 'Ad', 'Ah', 'As', ].includes(cardName);
